import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Modal from '../Modal'
import TextInput from '../TextInput'
import { useToggle } from '../utils/hooks'

const Cards = ({
  tablePayload,
  activeColumns,
  loading,
  renderHeader,
  renderPinned,
  renderCustom,
  renderModalFooter,
  modalTitle,
  showModal
}) => {
  const [isOpen, toggleOpen] = useToggle()
  const [cardIndex, setCardIndex] = useState(0)

  const renderDataCells = (row) => activeColumns.map((d, index) => {
    const isTextWrap = tablePayload.textWrap.includes(d.name)
    const toggleTextWrap = () => {
      if (isTextWrap) {
        tablePayload.setTextWrap((columns) => columns.filter((x) => x !== d.name))
      } else {
        tablePayload.setTextWrap([...tablePayload.textWrap, d.name])
      }
    }
    return (
      <div
        key={index}
        name={d.name}
        className='text-truncate px-3 pt-2'
      >
        {d.render
          ? <div className='form-group col-12 rounded mb-0 bg-light-hover read-only row'>
            <label className='form-label col-12 col-sm-4 mb-0'>{d.display}:</label>
            <div className='col-12 col-sm-8'>
              <span className='d-block text-truncate'>{d.render(row, isTextWrap, toggleTextWrap)}</span>
            </div>
          </div>
          : <TextInput label={d.display} name={d.name} readOnly inline values={row} labelWidth={4} inputWidth={8} className='mb-0' />
        }
      </div>
    )
  })

  const renderModalText = (row) => activeColumns.map((d, index) => (
    <div
      key={index}
      name={d.name}
      className='text-truncate mb-4'
    >
      <div className='form-group col-12 mb-0 rounded bg-light-hover'>
        <label
          htmlFor={d.name}
          className='form-label'>
          {d.display}
        </label>
        <div className='text-wrap text-break'>{d.render ? d.render(row) : row[d.name]}</div>
      </div>
    </div>
  ))

  return (
    <>
      {renderCustom
        ? <div className='tbody'>
          {/* Pinned Render always appear on top */}
          {renderPinned && renderPinned()}
          {tablePayload.visibleData.map((row, index) => (
            <div key={index}>
              {!loading && renderCustom(row, false, index)}
            </div>
          ))}
        </div>
        : <>
          <div className='tbody'>
            {tablePayload.visibleData.map((row, index) => (
              <div
                key={index}
                className={`list-item-box rounded mb-1 ${showModal && 'pointer card-hover'}`}
                onClick={() => {
                  if (showModal) {
                    toggleOpen()
                    setCardIndex(index)
                  }
                }}
              >
                {renderHeader && renderHeader(row, false, index)}
                {renderDataCells(row)}
              </div>
            ))}
          </div>

          {showModal &&
          <Modal
            isOpen={isOpen}
            onHide={toggleOpen}
            title={isOpen && modalTitle && modalTitle(tablePayload.visibleData[cardIndex])}
          >
            {isOpen && (
              <>
                <div className='mb-4'>
                  {renderModalText(tablePayload.visibleData[cardIndex])}
                </div>
                <div>
                  {renderModalFooter && renderModalFooter(tablePayload.visibleData[cardIndex])}
                </div>
              </>
            )}
          </Modal>
          }
        </>
      }

    </>
  )
}

Cards.propTypes = {
  activeColumns: PropTypes.array,
  tablePayload: PropTypes.object,
  loading: PropTypes.bool,
  renderHeader: PropTypes.func,
  renderPinned: PropTypes.func,
  renderCustom: PropTypes.func,
  renderModalFooter: PropTypes.func,
  modalTitle: PropTypes.func,
  showModal: PropTypes.bool
}

export default Cards
